import classNames from "classnames";
import { FunctionComponent } from "react";
import "./style.scss";

const SkeletonItem: FunctionComponent<{
  className?: string;
  color?: string;
  height?: number;
  type: "button" | "image" | "text";
  width?: number | string;
}> = ({ className, color, height, type, width }) => {
  return (
    <div
      className={classNames(`SkeletonItem ${className || ""}`, {
        "SkeletonItem-button": type === "button",
        "SkeletonItem-image": type === "image",
        "SkeletonItem-text": type === "text",
      })}
      style={{ background: color, height: height, width: width }}
    ></div>
  );
};

export default SkeletonItem;
